<template>
  <div class="advance-list">
    <!-- 搜索栏 -->
    <el-card class="search-card">
      <el-form :model="searchForm" inline>
        <el-form-item label="用户">
          <el-input
            v-model="searchForm.userName"
            placeholder="请输入用户名称"
            clearable
            style="width: 150px"
          />
        </el-form-item>

        <el-form-item label="项目">
          <el-select v-model="searchForm.teamId" placeholder="请选择" clearable style="width: 150px">
            <el-option
              v-for="team in teamOptions"
              :key="team.id"
              :label="team.name"
              :value="team.id"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="类型">
          <el-select v-model="searchForm.type" placeholder="请选择" clearable style="width: 120px">
            <el-option label="借支" value="advance" />
            <el-option label="还款" value="repay" />
          </el-select>
        </el-form-item>

        <el-form-item label="状态">
          <el-select v-model="searchForm.isRepaid" placeholder="请选择" clearable style="width: 120px">
            <el-option label="未归还" :value="0" />
            <el-option label="已归还" :value="1" />
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
          <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 表格 -->
    <el-card class="table-card mt-20">
      <el-table :data="advanceList" border stripe v-loading="loading">
        <el-table-column prop="id" label="ID" width="80" />
        <el-table-column label="借支人" min-width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.lenderName || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="借给谁" min-width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.borrowerName || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="来源" width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.recordSource === '包工头代记' ? 'warning' : 'success'" size="small">
              {{ scope.row.recordSource || '-' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="teamName" label="项目" min-width="120">
          <template slot-scope="scope">
            {{ scope.row.teamName || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="type" label="类型" width="80">
          <template slot-scope="scope">
            <el-tag :type="scope.row.type === 'repay' ? 'success' : 'warning'">
              {{ scope.row.type === 'repay' ? '还款' : '借支' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="amount" label="金额" width="100">
          <template slot-scope="scope">
            <span :class="scope.row.type === 'repay' ? 'text-success' : 'text-warning'">
             ¥{{ scope.row.amount }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="advanceDate" label="日期" width="120">
          <template slot-scope="scope">
            {{ scope.row.advanceDate || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="purpose" label="用途" min-width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.purpose">{{ scope.row.purpose }}</span>
            <span v-else class="text-muted">-</span>
          </template>
        </el-table-column>
        <el-table-column prop="reason" label="原因/备注" min-width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.reason">{{ scope.row.reason }}</span>
            <span v-else class="text-muted">-</span>
          </template>
        </el-table-column>
        <el-table-column prop="isRepaid" label="状态" width="80">
          <template slot-scope="scope">
            <el-tag :type="scope.row.isRepaid ? 'success' : 'danger'">
              {{ scope.row.isRepaid ? '已还' : '未还' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="160">
          <template slot-scope="scope">
            {{ formatDate(scope.row.createTime) }}
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        class="mt-20"
        background
        layout="total, prev, pager, next, sizes"
        :total="total"
        :page-size="pageSize"
        :current-page="pageNum"
        @current-change="handlePageChange"
        @size-change="handleSizeChange"
      />
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'AdvanceList',
  data() {
    return {
      searchForm: {
        userName: '',
        teamId: null,
        type: '',
        isRepaid: null
      },
      teamOptions: [],
      advanceList: [],
      loading: false,
      pageNum: 1,
      pageSize: 10,
      total: 0
    }
  },

  created() {
    this.loadTeamOptions()
    this.loadList()
  },

  methods: {
    async loadList() {
      this.loading = true
      try {
        const res = await this.$http.get('/admin/advance/list', {
          params: {
            pageNum: this.pageNum,
            pageSize: this.pageSize,
            ...this.searchForm
          }
        })
        this.advanceList = res?.records || res || []
        this.total = res?.total || this.advanceList.length
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false
      }
    },

    async loadTeamOptions() {
      try {
        const res = await this.$http.get('/admin/team/list', { params: { pageNum: 1, pageSize: 9999 } })
        this.teamOptions = res.records || []
      } catch (error) {
        console.error(error)
      }
    },

    handleSearch() {
      this.pageNum = 1
      this.loadList()
    },

    handleReset() {
      this.searchForm = {
        userName: '',
        teamId: null,
        type: '',
        isRepaid: null
      }
      this.pageNum = 1
      this.loadList()
    },

    handlePageChange(page) {
      this.pageNum = page
      this.loadList()
    },

    handleSizeChange(size) {
      this.pageSize = size
      this.pageNum = 1
      this.loadList()
    },

    formatDate(date) {
      if (!date) return '-'
      return new Date(date).toLocaleString('zh-CN')
    }
  }
}
</script>

<style scoped>
.advance-list {
  padding: 20px;
}

.search-card {
  margin-bottom: 20px;
}

.mt-20 {
  margin-top: 20px;
}

.text-success {
  color: #67C23A;
  font-weight: bold;
}

.text-warning {
  color: #E6A23C;
  font-weight: bold;
}

.text-muted {
  color: #999;
}
</style>
